'use strict';

"use strict";
const NOOP = () => {
};

exports.NOOP = NOOP;
//# sourceMappingURL=NOOP.js.map
